/**
 * Utilities for checking browser/SSR environment safely
 */

export function isBrowser(): boolean {
  return typeof window !== "undefined" && typeof document !== "undefined";
}

export function hasMatchMedia(): boolean {
  return isBrowser() && typeof window.matchMedia === "function";
}

/**
 * Detects if the current device is iOS (iPhone, iPad, iPod)
 * @returns true if the device is iOS, false otherwise
 */
export function isIOS(): boolean {
  if (!isBrowser()) return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
